module.exports = __webpack_public_path__ + "b66c94f1c1c6374e38d6486cf78f2eaf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/bat.png
// module id = 2485
// module chunks = 0